<template>
  <div>
    <van-popup
      v-model="showBuy"
      @close="close(2)"
      round
      position="bottom"
      closeable
    >
      <div class="pop">
        <div class="tt">
          <p class="orange f20">成为会员</p>
           <p
            v-show="!isWechat"
            @click="alis = true"
            style="margin: 18px 10px 18px 25px; color: #4a4a4a"
          >
            <img
              class="switch-tip-icon-img"
              src="https://t.alipayobjects.com/tfscom/T1Z5XfXdxmXXXXXXXX.png"
              alt="手机支付宝图标"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />支付宝付款
            <img
              :src="alis ? selected : select"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
                float: right;
              "
            />
          </p>
          <p
            v-show="!isWechat"
            @click="alis = false"
            style="margin: 18px 10px 18px 25px; color: #4a4a4a"
          >
            <img
              class="switch-tip-icon-img"
              src="../../../assets/img/test/wechat.png"
              alt="微信支付图标"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />微信付款
            <img
              :src="alis ? select : selected"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
                float: right;
              "
            />
          </p>
          <p class="f20 fr mr-0">
            合计： <span class="orange">￥{{ discount }}</span>
          </p>
        </div>
        <div class="tac">
          <van-button type="default" @click="tobeVip()" class="popbtn bgorange"
            >支付</van-button
          >
        </div>
      </div>
    </van-popup>
     <!-- <van-popup
      v-model="show"
      @close="close(0)"
      round
      position="bottom"
      closeable
    >
      <div class="pop">
        <div class="tt">
          <p class="orange f20">兑换码</p>
          <p
            v-show="!isWechat"
            @click="alis = true"
            style="margin: 18px 10px 18px 25px; color: #4a4a4a"
          >
            <img
              class="switch-tip-icon-img"
              src="https://t.alipayobjects.com/tfscom/T1Z5XfXdxmXXXXXXXX.png"
              alt="手机支付宝图标"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />支付宝付款
            <img
              :src="alis ? selected : select"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
                float: right;
              "
            />
          </p>
          <p
            v-show="!isWechat"
            @click="alis = false"
            style="margin: 18px 10px 18px 25px; color: #4a4a4a"
          >
            <img
              class="switch-tip-icon-img"
              src="../../../assets/img/test/wechat.png"
              alt="微信支付图标"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
              "
            />微信付款
            <img
              :src="alis ? select : selected"
              style="
                width: 19px;
                height: 19px;
                vertical-align: middle;
                margin-right: 10px;
                float: right;
              "
            />
          </p>
          <p class="mt-10">
            {{ testTitle }}
            <span class="fr">
              <span class="reduce" v-if="!number"></span>
              <span class="reduce-1" @click="reduce()" v-if="number"></span>
              <span class="number">{{ number }}</span>
              <span class="add" @click="add()"></span>
            </span>
          </p>
          <hr />
          <p>
            <span class="gray">优惠券</span>
            <span v-if="!coupon.amount" class="fr">无可用优惠券</span>
            <span v-if="coupon.amount" class="fr">-￥{{ coupon.amount }}></span>
          </p>
          <p class="f20 fr mr-0 mt-20">
            合计：
            <span class="orange">￥{{ payamount }}</span>
          </p>
        </div>
        <div class="tac">
          <van-button type="default" @click="pay()" class="popbtn bgorange"
            >支付
          </van-button>
          <p class="gray mt-10 mb-10">支付成功后即可获取赠送兑换码</p>
        </div>
      </div> -->
    </van-popup>
    <div class="content">
      <img
        class="back"
        @click="goHome"
        v-lazy="require('./../../../assets/img/back.png')"
      />
      <van-button class="btn mb-20" @click="buyVip">立即充值</van-button>
      <div class="btn2">
        <div>请输入会员兑换码</div>
        <div class="input">
          <input v-model="code1" class="inp" clearable />
          <div @click="getVip()" class="bttn">兑换</div>
        </div>
        <!-- 回到首页按钮 -->
        <div @click="goHomeIndex()" class="goHomeIndex">回到测评首页</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import crypto from "crypto";
import store from "./../../../store/index";
import {
  paychase,
  vipInfo,
  h5paychase,
  getUserInfo,
  exchangeVip,
} from "@/http/api";
export default {
  name: "vip",
  data() {
    return {
      code1: "",
      alis: true,
      showBuy: false,
      discount: 299,
      isWechat:'',
      img: require("./../../../assets/img/vipvip.png"),
      select: require("./../../../assets/img/test/select.png"),
      selected: require("./../../../assets/img/test/selected.png"),
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
     this.isWechat = ua.match(/MicroMessenger/i) == "micromessenger";
    localStorage["vipcode"] = "";
    this.code1 = this.$route.path.split("vip/")[1] || "";
    if (this.code1) {
      this.$nextTick(() => {
        document.querySelectorAll(".vd-content")[0].scrollTop = 1000;
      });
    }
    // console.log(document.querySelectorAll(".vd-content")[0].scrollTop =1000 )
    // document.querySelectorAll(".vd-content")[0].scrollTop = 1000;
    vipInfo().then((res) => {
      console.log(res);
      this.discount = res.data.discount_price;
      // this.img = res.data.image;
    });
    getUserInfo(this.user.user).then((msg) => {
      console.log(msg);
      const payload = msg.data.profile;
      store.commit("updateUser", payload);
      this.isVip = msg.data.profile.is_vip.key === "yes";
      // this.$message({
      //   message: "支付成功",
      //   type: "success"
      // });
      // setTimeout(() => {
      //   this.showBuy = !this.isVip;
      // }, 2000);
    });
  },
  methods: {
    goHome() {
      this.$router.push("/my/center");
    },
    //回到首页方法
    goHomeIndex() {
      this.$router.push("/index");
    },
    getVip() {
      if (!localStorage["site_current_token"]) {
        localStorage["vipcode"] = this.code1;
        this.$router.push("/login");
      }
      let params = {
        vip_redeem_code: this.code1,
      };
      exchangeVip(params).then((res) => {
        console.log(res);
        if (res.code == "SUCCESS") {
          this.$message({
            message: "兑换成功！",
            type: "success",
          });
          this.code1 = "";
          setTimeout(() => {
            this.$router.push("/my/center");
          }, 2000);
        } else {
          this.$message({
            message: "无效兑换码！",
            type: "error",
          });
        }
      });
    },
    buyVip() {
      this.showBuy = true;
    },
    tobeVip() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) != "micromessenger") {
        // if(localStorage['env'] == 'notWechat'){
        let param = {
          pay_type: "member",
          payment: this.alis ? "ali_pay" : "wechat_pay",
          amount: this.discount,
        };
        h5paychase(param).then((res) => {
          if (res.code == "SUCCESS") {
            console.log(res.data.pay_url);
            if (res.data.pay_url) {
              window.location.replace(res.data.pay_url);
            }
          }
        });
      } else {
        let param = {
          pay_type: "member",
          // member
          amount: this.discount,
        };
        paychase(param).then((res) => {
          console.log("支付的接口", res);
          let data = res.data.pay_params;
          let appId = data.appId;
          let timeStamp = data.timeStamp;
          let nonceStr = data.nonceStr;
          let signature = data.signature;
          let packages = data.package;
          let paySign = data.paySign;
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appId, //公众号名称，由商户传入
              timeStamp: timeStamp, //时间戳，自1970年以来的秒数
              nonceStr: nonceStr, //随机串
              package: packages,
              signType: "MD5", //微信签名方式：
              paySign: paySign, //微信签名
            },
            (res) => {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                getUserInfo(this.user.user).then((msg) => {
                  console.log(msg);
                  const payload = msg.data.profile;
                  store.commit("updateUser", payload);
                  this.$message({
                    message: "支付成功",
                    type: "success",
                  });
                  setTimeout(() => {
                    this.showBuy = false;
                    this.$router.go(-1);
                  }, 2000);
                });
              } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                this.$message({
                  message: "您已取消支付",
                  type: "error",
                });
              } else {
                this.$message({
                  message: "支付失败",
                  type: "error",
                });
              }
            }
          );
        });
      }
    },
    close() {
      this.showBuy = false;
    },
  },
};
</script>

<style lang="less" scoped>
.img {
  width: 100%;
}
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 20px;
  top: 20px;
}
.content {
  width: 100vw;
  height: 436vw;
  background-image: url("./../../../assets/img/vipvip.png");
  background-repeat: no-repeat;
  background-size: contain;
  text-align: center;
  position: relative;
}

.btn {
  background: #eba22a;
  width: 82vw;
  height: 45px;
  left: 0;
  border-radius: 18px;
  margin-left: 9vw;
  position: absolute;
  text-align: center;
  line-height: 45px;
  font-size: 18px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #ffffff;
  top: 305vw;
}

.btn2 {
  position: absolute;
  top: 325vw;
  font-size: 15px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #030303;
  line-height: 23px;
  margin: 0 43px;
  text-align: left;

  .input {
    margin-top: 10px;
    display: flex;

    .inp {
      background: #d7e7e8 !important;
      border-radius: 18px !important;
      border: none;
      width: 40vw;
      margin-right: 10px;
      height: 43px;
      padding-left: 40px;
      line-height: 43px;
    }

    .bttn {
      height: 45px;
      background: #42686e;
      border-radius: 18px;
      line-height: 43px;
      text-align: center;
      font-size: 18px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #ffffff;
      width: 22vw;
    }
  }
  // 回到首页按钮
  .goHomeIndex {
    height: 30px;
    background: #42686e;
    border-radius: 18px;
    line-height: 30px;
    text-align: center;
    font-size: 12px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #ffffff;
    width: 100%;
    margin-top: 3px;
  }
}

.pop {
  .tt {
    margin-top: 30px;
    width: 90%;
    margin-left: 5%;
  }

  .popbtn {
    width: 80%;
    margin-bottom: 0.2rem;
    margin-top: 0.8rem;
    // font-weight: bold;
    font-size: 18px;
    color: white;
    border-radius: 0.5rem;
  }

  .bgorange {
    background-color: #f7b270;
  }
}
</style>
